import AuthenticationService from '@/services/AuthenticationService';
import StorageService from '@/services/StorageService';
import sessionTimer from '../services/sessionTimer';
import moment from 'moment';

const SILENT_LOGIN_CALLED_KEY = 'called';

export const loginCheck = (router) => {
  router.beforeEach(async (to, from, next) => {
    const loggedUser = AuthenticationService.loggedUser();
    const tokenExpiresAt = loggedUser && moment(Number(loggedUser.tokenExpiresAt));
    const tokenIsValid = tokenExpiresAt && moment().diff(tokenExpiresAt) < 0;

    if (to.path === '/error') {
      next();
      return;
    }

    if (to.matched.some(m => m.meta.authenticated)) {
      if (!tokenExpiresAt && from.path !== '/logout' && to.path !== '/logout' && !StorageService.get(SILENT_LOGIN_CALLED_KEY)) {
        StorageService.add(SILENT_LOGIN_CALLED_KEY, 'true');
        await AuthenticationService.silentLogin();
        StorageService.remove(SILENT_LOGIN_CALLED_KEY);
        next();
        return;
      }

      if (!tokenIsValid) {
        await AuthenticationService.refreshTokens();
      } else if (!sessionTimer.isTimerStarted()) {
        await AuthenticationService.startSessionTimer();
      }

      next();
      return;
    }
    if (to.matched.every(m => m.meta.authenticated === false) && tokenIsValid) {
      next('/');
      return;
    }

    next();
  });
};

export const adminCheck = (router) => {
  router.beforeEach((to, from, next) => {
    const isAdmin = AuthenticationService.isAdmin();
    if (to.matched.some(m => m.meta.admin) && !isAdmin) {
      next('/');
      return;
    }

    next();
  });
};

export default (router) => {
  loginCheck(router);
  adminCheck(router);
};
